import { Layout } from "antd";
import styled from "styled-components";
import { NavLink } from "react-router-dom";

import { theme } from "styles/theme";
import { ScreenSize } from "styles/constants";

const { Sider } = Layout;

export const SidebarContainer = styled(Sider)`
  display: flex;
  flex-direction: column;
  /* width: 270px; */
  height: 100%;
  padding: 20px 20px;
  background: ${theme.primary.main} !important;
  box-shadow: 1px 0px 0px rgba(0, 0, 0, 0.15);

  border-right: 4px solid ${theme.primary.light};
  /* border-top-right-radius: 16px;
  border-bottom-right-radius: 16px; */
  transition: 0.5s;

  @media (min-width: ${ScreenSize.L}px) {
    /* width: 280px; */
    /* border-top-right-radius: 16px;
    border-bottom-right-radius: 16px; */
  }

  @media (min-width: ${ScreenSize.XL}px) {
    /* width: 290px; */
    /* border-top-right-radius: 16px;
    border-bottom-right-radius: 16px; */
  }
`;

export const LogoPlaceholder = styled.div`
  color: #f5f9ff;
  display: flex;
  font-weight: 800;
  align-items: center;
  justify-content: center;
  padding-bottom: 15px;
  margin-bottom: 25px;
  border-bottom: 3px #f5f9ff solid;

  svg {
    display: flex;
    font: 160px;
    width: 140px;
  }
`;

export const StyledNavLink = styled(NavLink).attrs({
  // activeClassName: "active",
})`
  display: inline-block;
  width: 100%;
  text-decoration: none;
  margin: 10px 0px;
  border-radius: 4px;
  transition: background-color 0.5s ease-in;
  display: block;
  cursor: pointer;
  padding-top: 1px;
  padding-bottom: 1px;
  border-radius: 4px;
  margin: 4px 0px;
  transition: background 300ms ease-in-out, border-left 300ms ease-in-out, left 300ms ease-in-out;

  &:hover {
    opacity: 0.75;
    color: #f5f9ff;
    background-color: rgba(0, 0, 0, 0.1);
    border-left: 4px solid ${theme.primary.light};
    transition: background 300ms ease-in-out, border-left 200ms ease-in-out, left 300ms ease-in-out;

    p {
      color: #f5f9ff;
    }

    svg {
      color: #f5f9ff;
    }
  }

  &.active {
    opacity: 1;
    background-color: #e9f6fe;
    border-left: 4px solid ${theme.primary.light};
    font-weight: 500;
    transition: background 300ms ease-in-out, border-left 300ms ease-in-out, left 300ms ease-in-out;
  }
`;

export const RouteItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 0px;
  padding-left: 15px;
  border-radius: 4px;

  svg {
    width: 23px;
    height: 23px;
    margin-right: 10px;
    color: #ffffffa1;
    font-weight: 900;
  }

  p {
    font-size: 15px;
    font-weight: 600;
    line-height: 20px;
    color: #ffffffa1;
    display: inline-block;
  }

  @media (min-width: ${ScreenSize.L}px) {
    padding: 10px 0px;
    padding-left: 13px;
    border-radius: 4px;

    p {
      display: inline-block;
      font-size: 15px;
      font-weight: 600;
      line-height: 13px;
      color: #ffffffa1;
    }
  }

  ${StyledNavLink}.active & {
    p {
      color: #00425f;
    }

    svg {
      color: #00425f;
    }
  }
`;
